import React, { Component } from 'react';
import MDReactComponent from 'markdown-react-js';
import { withPrefix } from 'gatsby-link'

const isClient = typeof window !== 'undefined'

function getCookie(name) {
    if (isClient){
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    } else return null;
}


class CookiesBox extends Component {
    constructor(props) {
		super(props);
		this.lang = props.lang;
        this.state = {
            viewCookies: props.stateComp
        }
        this.translations=props.translations;
        this.activeCookiesLayer = props.onClickActiveCookiesControl;
        this.linkRenderer=this.linkRenderer.bind(this);
    }

    linkRenderer(Tag, props, children, level) {
        if (Tag === 'a' && ( props.href==='#cookieLayerLink' || props.href==='#cookieControlLink' ) ) {
          props = {
            ...props,
            onClick: this.activeCookiesLayer
          };
        } else if (Tag =='a'){
            props = {
                ...props,
                target: '_blank'
              };
        }
        return <Tag {...props}>{children}</Tag>;
      }

    componentDidMount() {
        if(isClient) {
            var cookiesAccepted = isClient?getCookie('cookies-accepted')!=null:false;
            this.setState({viewCookies: !cookiesAccepted})
        }
    }

    componentWillReceiveProps(nextProps) {

        var existCookieBoxStorage = localStorage.getItem('cookiesMessageBicentury');

        if ( (nextProps.stateComp === false) && (existCookieBoxStorage === 'true') ) {
          this.setState({viewCookies: nextProps.stateComp})
          var d = new Date();
          d.setTime(d.getTime() + (182 * 24 * 60 * 60 * 1000));//6 meses  182 dias
          var expires = "expires="+d.toUTCString();
          window.localStorage.setItem('cookiesMessageBicentury', true);
          //document.cookie="cookies-accepted=false;"+expires+";path=/";
        }
    }    

    acceptCookies = () => {
        if(isClient) {
            var d = new Date();
            d.setTime(d.getTime() + (730 * 24 * 60 * 60 * 1000));//2 años meses son 730 dias
            var expires = "expires="+d.toUTCString();

            console.log('expira en : ', expires);
            document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=true" + ";" + expires + ";path=/";
            document.cookie = "cookies-accepted=true" + ";" + expires + ";path=/";
            this.setState({viewCookies: false})
            window.localStorage.setItem('cookiesMessageBicentury', true)
            //window.location.reload();
        }
    }

    rejectCookies = () => {
        console.log("REJECTING");
        if(isClient) {
            var d = new Date();
            d.setTime(d.getTime() + (730 * 24 * 60 * 60 * 1000));//2 años meses son 730 dias
            var expires = "expires="+d.toUTCString();
            document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false" + ";" + expires + ";path=/";
            document.cookie = "cookies-accepted=false" + ";" + expires + ";path=/";
            this.setState({viewCookies: false})
            window.localStorage.setItem('cookiesMessageBicentury', true)
            //window.location.reload();
        }
    }

    render() {

        const cookiesClass = `cookiesBox ${(this.state.viewCookies==true) ? '' : 'hideMessage'}`;

        return (

            <div className={cookiesClass}>
                <div className="cookiesBox-wrapper">
                    <div className='cookiesBox-animation'>
                        <img src={withPrefix('/images/tortita.gif')} />
                    </div>
                    <div className='cookiesBox-message'>
                        <h4>{this.translations.cookielayer_title}</h4>
                        <MDReactComponent text={this.translations.cookielayer_text} onIterate={this.linkRenderer} />
                        
                        <div className="cookiesBox-buttons">
                            <button className='btn notdef' onClick={this.rejectCookies}>{this.translations.cookielayer_reject}</button>
                            <button className='btn notdef'><a href="#cookieControlLink" onClick={this.activeCookiesLayer}>{this.translations.cookielayer_configure}</a></button>
                            <button className='btn' onClick={this.acceptCookies}>{this.translations.cookielayer_acceptall}</button>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
};

export default CookiesBox;



// WEBPACK FOOTER //
// ./src/components/cookiesBox/index.js